<template>
    <div v-if="visible" class="mc-alert" :class="[typeClass, {'is-top': isTop}]" :style="{'width': width}">
        <span v-if="showIcon" class="mc-alert__icon"><i class="fa" :class="iconClass"></i></span>
        <span class="mc-alert__content">
            <slot></slot>
        </span>
        <a class="mc-alert__close" v-if="closable" @click="visible=false"><i class="fa fa-close-custom"></i></a>
    </div>
</template>
<script type="text/ecmascript-6">
    /**
     * 提供配置项>>>
     * type             提示类型         success/info/warning/error
     * show-icon        是否显示图标      默认false
     * closable         是否可以关闭      默认false
     */

    import McContainer from './base-container'

    const TYPE_CLASS_MAP = {
        'success': 'mc-alert--success',
        'warning':  'mc-alert--warning',
        'error': 'mc-alert--error',
        'info': 'mc-alert--info'
    };
    const TYPE_ICON_MAP = {
        'success': 'fa-check-circle',
        'warning':  'fa-exclamation-circle',
        'error': 'fa-times-circle',
        'info': 'fa-question-circle'
    };

    export default {
        name: 'McAlert',
        components: {
            McContainer
        },
        props: {
            type: {
                type: String,
                default: 'info'
            },
            isTop: {
                type: Boolean,
                default: false
            },
            closable: {
                type: Boolean,
                default: false
            },
            showIcon: {
                type: Boolean,
                default: false
            },
            autoClose: {
                type: [Boolean, Number],
                default: 0
            },
            width: {
                type: String,
                default: '100%'
            }
        },
        data: function () {
            return {
                visible: true
            }
        },
        watch: {

        },
        computed: {
            typeClass: function () {
                return TYPE_CLASS_MAP[this.type] || 'info';
            },
            iconClass: function () {
                return TYPE_ICON_MAP[this.type] || '';
            }
        },
        mounted: function () {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/base-alert.vue